module.exports = __webpack_public_path__ + "media/images/proof_links/colored/rottentomatoes-3359fba64fdeddbcdbbd6dd5e8895b68.svg";